
<script>
import { Icon } from 'element-ui'
import SvgIconMe from './svg-icon-me.vue'
import { EL_ICON_PREFIX, LOCAL_ICON_PREFIX } from './util.js'

export default {
    name: 'Icon',
    components:{Icon,SvgIconMe},
    props:{
        //icon 名称，对应icon
        name: {
            type: String,
            required: true
        },
        // 大小
        fontsize: {
            type: String,
            default: '14px'
        },
        //颜色
        color: {
            type: String,
            default: 'inherit'
        }
    }, 
    
    render:function(createElement){
     
            if (this.name.indexOf(EL_ICON_PREFIX) === 0) {
                // 或者使用 'el-icon'
                return createElement(
                    Icon,
                    {
                        style:{
                            color: this.color,
                            fontSize:this.fontsize,
                        },
                        props:{
                            name:this.name.replace(EL_ICON_PREFIX, '')
                        }
                    },
                )
            }
        if (this.name.indexOf(LOCAL_ICON_PREFIX) === 0) {
            // 本地icon
            
            // return createElement(
            //         'i',
            //         {
            //             class: ['local-icon']
            //         },
            //        [createElement(SvgIconMe,{props:{
            //             color: this.color,
            //             size:this.fontsize,
            //             name:this.name.replace(LOCAL_ICON_PREFIX, ''),
            //         }},'fff')]
                    
            //     )

                 return createElement(
                   SvgIconMe,{props:{
                        color: this.color,
                        size:this.fontsize,
                        name:this.name.replace(LOCAL_ICON_PREFIX, ''),
                    }}
                    
                )
        }
        
    }
}

</script>